import React from 'react'
import DefaultNicheTemplate from '../templates/DefaultNicheTemplate'

function Niche() {
  return (<DefaultNicheTemplate />)
}

export default Niche
